module.exports = __webpack_public_path__ + "img/vertical_3_7_1.a972812e.png";